export const GLOBAL_FORBIDDEN_ACCESS_ERROR_MESSAGE = "Vous n'avez pas la permission d'accéder à cette page.";
export const GLOBAL_FORBIDDEN_ACTION_ERROR_MESSAGE = "Vous n'avez pas la permission d'effectuer cette action.";
export const GLOBAL_FORBIDDEN_ERROR_DESCRIPTION = "Veuillez contacter la personne disposant du role admin dans votre CSE.";
